module.exports = __webpack_public_path__ + "images/ds-cml2024-banner-block.webp";